export default "__VITE_ASSET__5iOvVc8C__"